import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { queryClient } from 'providers';

import { TransectionApiServices, WalletsDTO } from '../api/transection-api.service';

const { createWallet } = TransectionApiServices();

export const useCreateWallet = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: WalletsDTO) => {
            return createWallet(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success("Wallet has been created successfully!!");
            },
        },
    );
};